import axios from 'axios';
import { getAuth, getIdentityId, generateGuid } from 'services/Authentication';
import { isSlsOffline } from 'services/environment';
import Promise from 'promise';
import qs from 'qs';
import { parseError, parseBody } from 'services/ApiService';

export const timeout = 3000;
export const retries = 2; // two more after the original request
// TODO constants please for these parameters
export const API_CONFIG = {
    apiEndpoints: {
        endpoints: {
            projectCostPriority: {
                method: 'GET',
                name: 'projectCostPriority',
                uri: '/orgcostpriorities/{orgid}/projectCostPriorities/{projectCostPriorityId}',
            },
            projectCostPrioritys: {
                method: 'GET',
                name: 'projectCostPrioritys',
                uri: '/orgcostpriorities/{orgid}/projectCostPriorities',
            },
            updateProjectCostPriority: {
                method: 'PUT',
                name: 'updateProjectCostPriority',
                uri: '/orgcostpriorities/{orgid}/projectCostPriorities',
            },
            addProjectCostPriority: {
                method: 'POST',
                name: 'addProjectCostPriority',
                uri: '/orgcostpriorities/{orgid}/projectCostPriorities',
            },
            deleteProjectCostPriority: {
                method: 'DELETE',
                name: 'deleteProjectCostPriority',
                uri: '/orgcostpriorities/{orgid}/projectCostPriorities/{projectCostPriorityId}',
            },
            projectBusPriority: {
                method: 'GET',
                name: 'projectBusPriority',
                uri: '/orgbuspriorities/{orgid}/projectBusPriorities/{projectBusPriorityId}',
            },
            projectBusPrioritys: {
                method: 'GET',
                name: 'projectBusPrioritys',
                uri: '/orgbuspriorities/{orgid}/projectBusPriorities',
            },
            updateProjectBusPriority: {
                method: 'PUT',
                name: 'updateProjectBusPriority',
                uri: '/orgbuspriorities/{orgid}/projectBusPriorities',
            },
            addProjectBusPriority: {
                method: 'POST',
                name: 'addProjectBusPriority',
                uri: '/orgbuspriorities/{orgid}/projectBusPriorities',
            },
            deleteProjectBusPriority: {
                method: 'DELETE',
                name: 'deleteProjectBusPriority',
                uri: '/orgbuspriorities/{orgid}/projectBusPriorities/{projectBusPriorityId}',
            },
            issueDisplayData: {
                method: 'GET',
                name: 'issueDisplayData',
                uri: '/orgissue/{orgid}/issue/{issueId}/displayData',
            },
            issue: {
                method: 'GET',
                name: 'issue',
                uri: '/orgissue/{orgid}/issue/{issueId}',
            },
            issues: {
                method: 'GET',
                name: 'issues',
                uri: '/orgissue/{orgid}/issues',
            },
            updateIssue: {
                method: 'PUT',
                name: 'updateIssue',
                uri: '/orgissue/{orgid}/issue',
            },
            addIssue: {
                method: 'POST',
                name: 'addIssue',
                uri: '/orgissue/{orgid}/issue',
            },
            deleteIssue: {
                method: 'DELETE',
                name: 'deleteIssue',
                uri: '/orgissue/{orgid}/issue/{issueId}',
            },
            initiativeDisplayData: {
                method: 'GET',
                name: 'initiative',
                uri: '/orginitiative/{orgid}/initiative/{initiativeId}/displayData',
            },
            initiative: {
                method: 'GET',
                name: 'initiative',
                uri: '/orginitiative/{orgid}/initiative/{initiativeId}',
            },
            initiatives: {
                method: 'GET',
                name: 'initiatives',
                uri: '/orginitiative/{orgid}/initiatives',
            },
            updateInitiative: {
                method: 'PUT',
                name: 'updateInitiative',
                uri: '/orginitiative/{orgid}/initiative',
            },
            addInitiative: {
                method: 'POST',
                name: 'addInitiative',
                uri: '/orginitiative/{orgid}/initiative',
            },
            deleteInitiative: {
                method: 'DELETE',
                name: 'deleteInitiative',
                uri: '/orginitiative/{orgid}/initiative/{initiativeId}',
            },
            productDisplayData: {
                method: 'GET',
                name: 'productDisplayData',
                uri: '/orgproduct/{orgid}/product/{productId}/displayData',
            },
            product: {
                method: 'GET',
                name: 'product',
                uri: '/orgproduct/{orgid}/product/{productId}',
            },
            products: {
                method: 'GET',
                name: 'products',
                uri: '/orgproduct/{orgid}/products',
            },
            updateProduct: {
                method: 'PUT',
                name: 'updateProduct',
                uri: '/orgproduct/{orgid}/product',
            },
            addProduct: {
                method: 'POST',
                name: 'addProduct',
                uri: '/orgproduct/{orgid}/product',
            },
            deleteProduct: {
                method: 'DELETE',
                name: 'deleteProduct',
                uri: '/orgproduct/{orgid}/product/{productId}',
            },
            team: {
                method: 'GET',
                name: 'team',
                uri: '/orgteam/{orgid}/team/{teamId}',
            },
            teams: {
                method: 'GET',
                name: 'teams',
                uri: '/orgteam/{orgid}/teams',
            },
            updateTeam: {
                method: 'PUT',
                name: 'updateTeam',
                uri: '/orgteam/{orgid}/team',
            },
            addTeam: {
                method: 'POST',
                name: 'addTeam',
                uri: '/orgteam/{orgid}/team',
            },
            deleteTeam: {
                method: 'DELETE',
                name: 'deleteTeam',
                uri: '/orgteam/{orgid}/team/{teamId}',
            },
            member: {
                method: 'GET',
                name: 'member',
                uri: '/orgmember/{orgid}/member/{memberId}',
            },
            members: {
                method: 'GET',
                name: 'members',
                uri: '/orgmember/{orgid}/members',
            },
            updateMember: {
                method: 'PUT',
                name: 'updateMember',
                uri: '/orgmember/{orgid}/member',
            },
            addMember: {
                method: 'POST',
                name: 'addMember',
                uri: '/orgmember/{orgid}/member',
            },
            deleteMember: {
                method: 'DELETE',
                name: 'deleteMember',
                uri: '/orgmember/{orgid}/member/{memberId}',
            },
            valueStreamDisplayData: {
                method: 'GET',
                name: 'valueStreamDisplayData',
                uri: '/orgvaluestream/{orgid}/valueStream/{valueStreamId}/displayData',
            },
            valueStream: {
                method: 'GET',
                name: 'valueStream',
                uri: '/orgvaluestream/{orgid}/valueStream/{valueStreamId}',
            },
            valueStreams: {
                method: 'GET',
                name: 'valueStreams',
                uri: '/orgvaluestream/{orgid}/valueStreams',
            },
            updateValueStream: {
                method: 'PUT',
                name: 'updateValueStream',
                uri: '/orgvaluestream/{orgid}/valueStream',
            },
            addValueStream: {
                method: 'POST',
                name: 'addValueStream',
                uri: '/orgvaluestream/{orgid}/valueStream',
            },
            deleteValueStream: {
                method: 'DELETE',
                name: 'deleteValueStream',
                uri: '/orgvaluestream/{orgid}/valueStream/{valueStreamId}',
            },
            featureDisplayData: {
                method: 'GET',
                name: 'featureDisplayData',
                uri: '/orgfeature/{orgid}/feature/{featureId}/displayData',
            },
            feature: {
                method: 'GET',
                name: 'feature',
                uri: '/orgfeature/{orgid}/feature/{featureId}',
            },
            features: {
                method: 'GET',
                name: 'features',
                uri: '/orgfeature/{orgid}/features',
            },
            updateFeature: {
                method: 'PUT',
                name: 'updateFeature',
                uri: '/orgfeature/{orgid}/feature',
            },
            updateFeatures: {
                method: 'PUT',
                name: 'updateFeatures',
                uri: '/orgfeature/{orgid}/features',
            },
            addFeature: {
                method: 'POST',
                name: 'addFeature',
                uri: '/orgfeature/{orgid}/feature',
            },
            deleteFeature: {
                method: 'DELETE',
                name: 'deleteFeature',
                uri: '/orgfeature/{orgid}/feature/{featureId}',
            },
            projectIssue: {
                method: 'GET',
                name: 'projectIssue',
                uri: '/orgprojectissues/{orgid}/project/{projectId}/issue/{projectIssueId}',
            },
            projectIssues: {
                method: 'GET',
                name: 'projectIssues',
                uri: '/orgprojectissues/{orgid}/project/{projectId}/issues',
            },
            updateProjectIssue: {
                method: 'PUT',
                name: 'updateProjectIssue',
                uri: '/orgprojectissues/{orgid}/project/{projectId}/issue',
            },
            addProjectIssue: {
                method: 'POST',
                name: 'addProjectIssue',
                uri: '/orgprojectissues/{orgid}/project/{projectId}/issue',
            },
            deleteProjectIssue: {
                method: 'DELETE',
                name: 'deleteProjectIssue',
                uri: '/orgprojectissues/{orgid}/project/{projectId}/issue/{projectIssueId}',
            },
            projects: {
                method: 'GET',
                name: 'projects',
                uri: '/orgproject/{orgid}/projects',
            },
            updateProject: {
                method: 'PUT',
                name: 'updateProject',
                uri: '/orgproject/{orgid}/project',
            },
            addProject: {
                method: 'POST',
                name: 'addProject',
                uri: '/orgproject/{orgid}/project',
            },
            addProjects: {
                method: 'POST',
                name: 'addProjects',
                uri: '/orgproject/{orgid}/projects',
            },
            deleteProject: {
                method: 'DELETE',
                name: 'deleteProject',
                uri: '/orgproject/{orgid}/project/{id}',
            },
            importJiraProjects: {
                method: 'GET',
                name: 'importJiraProjects',
                uri: '/orgproject/{orgid}/importProjects',
            },
            signIn: {
                method: 'POST',
                name: 'signIn',
                uri: '/authorisation/auth/login',
            },
            identity: {
                method: 'GET',
                name: 'identity',
                uri: '/organisation/auth/identity',
            },
            organisations: {
                method: 'GET',
                name: 'organisations',
                uri: '/organisation/organisations',
            },
            updateOrganisation: {
                method: 'PUT',
                name: 'updateOrganisation',
                uri: '/organisation/organisation',
            },
            addOrganisation: {
                method: 'POST',
                name: 'addOrganisation',
                uri: '/authorisation/auth/register',
            },
            organisationSurveyAnswers: {
                method: 'GET',
                name: 'organisationSurveyAnswers',
                uri: '/orgsurveyanswers/{orgid}/survey/{orgSurveyId}/answers',
            },
            addOrgSurveyAnswers: {
                method: 'POST',
                name: 'addOrgSurveyAnswers',
                uri: '/orgsurveyanswers/{orgid}/survey/answers',
            },
            updateOrgSurveyAnswers: {
                method: 'PUT',
                name: 'updateOrgSurveyAnswers',
                uri: '/orgsurveyanswers/{orgid}/survey/answers',
            },
            compareOrgSurveyAnswers: {
                method: 'POST',
                name: 'compareOrgSurveyAnswers',
                uri: '/orgsurveyanswers/{orgid}/survey/answersCompareData',
            },
            employees: {
                method: 'GET',
                name: 'employees',
                uri: '/organisation/{orgid}/persons',
            },
            organisationStatistics: {
                method: 'GET',
                name: 'employees',
                uri: '/organisation/{orgid}/statistics',
            },
            updateEmployee: {
                method: 'PUT',
                name: 'updateEmployee',
                uri: '/organisation/{orgid}/person',
            },
            addEmployee: {
                method: 'POST',
                name: 'addEmployee',
                uri: '/authorisation/auth/register',
            },
            surveyQuestions: {
                method: 'GET',
                name: 'surveyQuestions',
                uri: '/survey/survey-questions',
            },
            surveys: {
                method: 'GET',
                name: 'surveys',
                uri: '/survey/surveys',
            },
            updateSurvey: {
                method: 'PUT',
                name: 'updateSurvey',
                uri: '/survey/survey',
            },
            addSurvey: {
                method: 'POST',
                name: 'addSurvey',
                uri: '/survey/survey',
            },
            surveyGroups: {
                method: 'GET',
                name: 'surveyGroups',
                uri: '/survey/survey-groups',
            },
            updateSurveyGroup: {
                method: 'PUT',
                name: 'updateSurveyGroup',
                uri: '/survey/survey-group',
            },
            addSurveyGroup: {
                method: 'POST',
                name: 'addSurveyGroup',
                uri: '/survey/survey-group',
            },
            surveyGroupQuestions: {
                method: 'GET',
                name: 'surveyGroupQuestions',
                uri: '/survey/{surveyGroupId}/survey-group-questions',
            },
            addSurveyGroupQuestion: {
                method: 'POST',
                name: 'addSurveyGroupQuestion',
                uri: '/survey/{surveyGroupId}/survey-group-question',
            },
            deleteSurveyGroupQuestion: {
                method: 'DELETE',
                name: 'addSurveyGroupQuestion',
                uri: '/survey/{surveyGroupId}/survey-group-question',
            },
            projectPrioritys: {
                method: 'GET',
                name: 'projectPrioritys',
                uri: '/orgproject/{orgid}/project/{projectId}/prioritys',
            },
            updateProjectPriority: {
                method: 'PUT',
                name: 'updateProjectPriority',
                uri: '/orgproject/{orgid}/project/{projectId}/priority',
            },
            addProjectPriority: {
                method: 'POST',
                name: 'addProjectPriority',
                uri: '/orgproject/{orgid}/project/{projectId}/priority',
            },
            deleteProjectPriority: {
                method: 'DELETE',
                name: 'deleteProjectPriority',
                uri: '/orgproject/{orgid}/project/{projectId}/priority/{id}',
            },
            updateBusPriorities: {
                method: 'PUT',
                name: 'updateBusPriorities',
                uri: '/orgproject/{orgid}/project/busPriorities',
            },
            updateCostPriorities: {
                method: 'PUT',
                name: 'updateCostPriorities',
                uri: '/orgproject/{orgid}/project/costPriorities',
            },
            security: {
                method: 'GET',
                name: 'security',
                uri: '/orgsecurity/{orgid}/security/{securityId}',
            },
            securitys: {
                method: 'GET',
                name: 'securitys',
                uri: '/orgsecurity/{orgid}/securitys',
            },
            updateSecurity: {
                method: 'PUT',
                name: 'updateSecurity',
                uri: '/orgsecurity/{orgid}/security',
            },
            addSecurity: {
                method: 'POST',
                name: 'addSecurity',
                uri: '/orgsecurity/{orgid}/security',
            },
            deleteSecurity: {
                method: 'DELETE',
                name: 'deleteSecurity',
                uri: '/orgsecurity/{orgid}/security/{securityId}',
            },
            businessUnit: {
                method: 'GET',
                name: 'businessUnit',
                uri: '/orgbusunit/{orgid}/businessUnit/{businessUnitId}',
            },
            businessUnits: {
                method: 'GET',
                name: 'businessUnits',
                uri: '/orgbusunit/{orgid}/businessUnits',
            },
            updateBusinessUnit: {
                method: 'PUT',
                name: 'updateBusinessUnit',
                uri: '/orgbusunit/{orgid}/businessUnit',
            },
            addBusinessUnit: {
                method: 'POST',
                name: 'addBusinessUnit',
                uri: '/orgbusunit/{orgid}/businessUnit',
            },
            deleteBusinessUnit: {
                method: 'DELETE',
                name: 'deleteBusinessUnit',
                uri: '/orgbusunit/{orgid}/businessUnit/{businessUnitId}',
            },
            portfolioDashboard: {
                method: 'GET',
                name: 'portfolioDashboard',
                uri: '/orgportfolio/{orgid}/portfolio/{portfolioId}/dashboard',
            },
            portfolio: {
                method: 'GET',
                name: 'portfolio',
                uri: '/orgportfolio/{orgid}/portfolio/{portfolioId}',
            },
            portfolios: {
                method: 'GET',
                name: 'portfolios',
                uri: '/orgportfolio/{orgid}/portfolios',
            },
            updatePortfolio: {
                method: 'PUT',
                name: 'updatePortfolio',
                uri: '/orgportfolio/{orgid}/portfolio',
            },
            addPortfolio: {
                method: 'POST',
                name: 'addPortfolio',
                uri: '/orgportfolio/{orgid}/portfolio',
            },
            deletePortfolio: {
                method: 'DELETE',
                name: 'deletePortfolio',
                uri: '/orgportfolio/{orgid}/portfolio/{portfolioId}',
            },
        },
        //baseUrl: 'http://localhost:8882',
        baseUrl: 'https://lambda.dyn.theoctoguide.com',
        // baseUrl: 'https://kevxw9ogqj.execute-api.ap-southeast-2.amazonaws.com/dev',
        apiKeys: {},
    },
};

let instance = axios.create({
    // baseURL: API_CONFIG.apiEndpoints.baseUrl,
    timeout: timeout,
    paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false });
    },
});

// request header
instance.interceptors.request.use(
    (config) => {
        // Do something before request is sent
        // TODO move x-api-key to config
        const apiToken = getAuth();
        let apiKey;

        config.baseURL = API_CONFIG.apiEndpoints.baseUrl;
        // need to set the apiKey for each gateway group and change the baseURL if connected to sls-offline
        if (config.url.indexOf('/authorisation/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.AUTH_OFFLINE_PORT);
            }
            apiKey = process.env.AUTH_API_KEY;
        }
        if (config.url.indexOf('/orgsecurity/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.SECURITY_OFFLINE_PORT);
            }
            apiKey = process.env.SECURITY_API_KEY;
        }
        if (config.url.indexOf('/orgprojectissues/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_ISSUE_OFFLINE_PORT);
            }
            apiKey = process.env.PROJECT_ISSUE_API_KEY;
        }
        if (config.url.indexOf('/orgbusunit/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.BUSINESS_UNIT_OFFLINE_PORT);
            }
            apiKey = process.env.BUSINESS_UNIT_API_KEY;
        }
        if (config.url.indexOf('/orgportfolio/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PORTFOLIO_OFFLINE_PORT);
            }
            apiKey = process.env.PORTFOLIO_API_KEY;
        }
        if (config.url.indexOf('/orgfeature/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.FEATURE_OFFLINE_PORT);
            }
            apiKey = process.env.FEATURE_API_KEY;
        }
        if (config.url.indexOf('/orgvaluestream/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.VALUE_STREAM_OFFLINE_PORT);
            }
            apiKey = process.env.VALUE_STREAM_API_KEY;
        }
        if (config.url.indexOf('/orgmember/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.MEMBER_OFFLINE_PORT);
            }
            apiKey = process.env.MEMBER_API_KEY;
        }
        if (config.url.indexOf('/orgteam/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.TEAM_OFFLINE_PORT);
            }
            apiKey = process.env.TEAM_API_KEY;
        }
        if (config.url.indexOf('/orgproduct/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PRODUCT_OFFLINE_PORT);
            }
            apiKey = process.env.PRODUCT_API_KEY;
        }
        if (config.url.indexOf('/orginitiative/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.INITIATIVE_OFFLINE_PORT);
            }
            apiKey = process.env.INITIATIVE_API_KEY;
        }
        if (config.url.indexOf('/orgissue/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.ISSUE_OFFLINE_PORT);
            }
            apiKey = process.env.ISSUE_API_KEY;
        }
        if (config.url.indexOf('/orgbuspriorities/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_BUS_PRIORITIES_OFFLINE_PORT);
            }
            apiKey = process.env.PROJECT_BUS_PRIORITY_API_KEY;
        }
        if (config.url.indexOf('/orgcostpriorities/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_COST_PRIORITY_OFFLINE_PORT);
            }
            apiKey = process.env.PROJECT_COST_PRIORITY_API_KEY;
        }
        // organisation hosts survey/answers so check for that first otherwise either org or survey endpoint
        // i.e any url that starts with /organisation/ should go here
        if (config.url.indexOf('/orgsurveyanswers/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.ORG_SURVEY_ANSWERS_OFFLINE_PORT);
            }
            apiKey = process.env.ANSWERS_API_KEY;
        } else if (config.url.indexOf('/orgproject/') !== -1) {
            if (isSlsOffline()) {
                config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.PROJECT_OFFLINE_PORT);
            }
            apiKey = process.env.PROJECT_API_KEY;
        } else {
            if (config.url.indexOf('/organisation/') !== -1) {
                if (isSlsOffline()) {
                    config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.ORG_OFFLINE_PORT);
                }
                apiKey = process.env.ORG_API_KEY;
            }
            if (config.url.indexOf('/survey/') !== -1) {
                if (isSlsOffline()) {
                    config.baseURL = process.env.OFFLINE_PROTOCOL_HOST_PREFIX.concat(process.env.SURVEY_OFFLINE_PORT);
                }
                apiKey = process.env.SURVEY_API_KEY;
            }
        }
        // add to any headers that already exist
        const currentHeaders = config.headers;
        config.headers = {
            ...currentHeaders,
            'Content-Type': 'application/json',
            'x-api-key': apiKey,
            Authorization: apiToken ? apiToken : null,
            uuid: getIdentityId(),
            correlationid: generateGuid(),
        };
        console.log('Starting Request', config); // TODO should not show this on live site
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// response parse
instance.interceptors.response.use(
    (response) => {
        console.log('Request was successful ', JSON.stringify(response.data));
        return parseBody(response);
    },
    (error) => {
        if (error.response) {
            console.warn('Error status', error.response.status);
            console.warn('Error message', parseError(error.response.data));
            return parseError(error.response.data);
        } else {
            return Promise.reject(error);
        }
    }
);

export const isMockData = () => {
    return isSlsOffline() && API_CONFIG.apiEndpoints.baseUrl === 'https://lambda.dyn.theoctoguide.com';
};

export const endpoint = (name) => {
    const endpointConfig = API_CONFIG.apiEndpoints.endpoints[name];
    if (endpointConfig) {
        const uri = endpointConfig.uri;
        return { uri, method: endpointConfig.method, name: endpointConfig.name };
    }
    return { uri: '', name, method: 'GET' };
};

/**
 * replace all the endpoint path parameters with their corresponding path parameter values
 * @param {*} endpoint
 * @param {*} pathParams
 * @param {*} pathParamValues
 */
export const replaceEndpointPathParams = (endpoint, pathParams, pathParamValues) => {
    let uri = endpoint;
    if (uri && pathParams && pathParamValues && pathParams?.length === pathParamValues?.length) {
        // replace all the params in the uri with corresponding values
        let count = 0;
        for (const pathParam of pathParams) {
            if (pathParam) {
                uri = uri.replace('{'.concat(pathParam).concat('}'), pathParamValues[count++]);
            }
        }
    }
    return uri;
};

export const apiKey = (name) => {
    return API_CONFIG.apiKeys[name];
};

// export after the instance is created
export const apiConfig = instance;



// WEBPACK FOOTER //
// ./services/ApiConfig.js